import { Component, OnInit } from '@angular/core';
import {UserService} from "../../shared/user.service";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {UtilService} from "../../shared/util.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {UserModel} from "../../model/user.model";

@Component({
    selector: 'app-user-edit',
    templateUrl: './user-edit.component.html',
    standalone: false
})
export class UserEditComponent implements OnInit {
  searchText = null;
  user = null;
  companies = [];
  roles = [];

  constructor(
    private service: UserService,
    private route: ActivatedRoute,
    private router: Router,
    private util: UtilService,
    private _snackBar: MatSnackBar,
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params:Params) => {
      let id = params['id'] ? params['id'] : null;
      if (!id) {
        return this.router.navigate(['/data/user']);
      } else {
        this.fetchUser(id);
      }
    })
  }


  fetchUser(id) {
    this.service.getUserByID(id).subscribe((resp: any) => {
      if (resp.user) {
        this.user = new UserModel(resp.user);
      }
      if (resp.companies) {
        this.companies = resp.companies.map(c => {
          if (this.util.isItemInArray(c, this.user.companies)) {
            c.checked = true;
          }
          return c;
        });
      }
      if (resp.roles) {
        this.roles = resp.roles
      }
    })
  }

  onSlideChange(company) {
    company.checked = !company.checked;

    if (company.checked) {
      this.user.companies.push(company);
    } else {
      this.user.companies = this.util.findAndReplaceItemInArray(company, this.user.companies, true);
    }
  }

  saveUser() {
    const selectedCompanies = this.user.companies ? this.user.companies.map(c => c.id) : [];
    this.service.saveUser(this.user.username, selectedCompanies, this.user.role_id).subscribe((resp:any) => {
      if (resp && resp.success) {
        this._snackBar.open("Sikeres mentés!", "OK", {duration: 5000});
        return this.router.navigate(['/data/user']);
      }
    });
  }

}
